"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

require("../../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../general/Link"));

var _FlexRow = _interopRequireWildcard(require("../layout/FlexRow"));

var _FormSearchBox = _interopRequireDefault(require("./FormSearchBox"));

var _InputWidths = _interopRequireDefault(require("./InputWidths"));

var _Text = _interopRequireWildcard(require("../general/Text"));

var _KeywordSearchView$de;

var KeywordSearchView = function KeywordSearchView(_ref) {
  var className = _ref.className,
      dataId = _ref["data-id"],
      onKeyDown = _ref.onKeyDown,
      onResultClick = _ref.onResultClick,
      onValueChange = _ref.onValueChange,
      queryString = _ref.queryString,
      results = _ref.results,
      selectedIndex = _ref.selectedIndex,
      title = _ref.title;
  var selectedRef = (0, _react.useRef)();
  var containerRef = (0, _react.useRef)();

  var _renderSearchResult = function _renderSearchResult(result, idx) {
    var _context, _context2;

    var id = result.id,
        label = result.label,
        _result$root = result.root,
        rootId = _result$root.id,
        _result$root$label = _result$root.label,
        root = _result$root$label === void 0 ? rootId : _result$root$label,
        section = result.section;

    var resultClicked = function resultClicked() {
      return onResultClick(result);
    };

    var isSelected = idx === selectedIndex;
    var resultClass = "keyword-search__result ".concat(isSelected ? "keyword-search__result--selected" : "");

    var resultTitle = /*#__PURE__*/_react.default.createElement(_FlexRow.default, {
      alignment: _FlexRow.alignments.BOTTOM,
      spacing: _FlexRow.spacingOptions.XS
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: "keyword-search__result-label"
    }, isSelected ? {
      ref: selectedRef
    } : {}), "".concat(label, " - ")), /*#__PURE__*/_react.default.createElement(_Text.default, {
      className: "keyword-search__result-root",
      inline: true,
      type: _Text.textTypes.PARENTLABEL,
      overflow: _Text.default.overflowTypes.ELLIPSIS
    }, root), /*#__PURE__*/_react.default.createElement(_Text.default, {
      inline: true,
      type: _Text.textTypes.PARENTLABEL,
      className: "keyword-search__result-carat"
    }, section ? "> " : ""), section && /*#__PURE__*/_react.default.createElement(_Text.default, {
      className: "keyword-search__result-section",
      inline: true,
      type: _Text.textTypes.PARENTLABEL,
      overflow: _Text.default.overflowTypes.ELLIPSIS
    }, section.label || section.id));

    var sanitizedLabel = label.toLowerCase().replace(/[^0-9a-z]/gi, "");
    return /*#__PURE__*/_react.default.createElement("li", {
      key: id
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: resultClass,
      "data-id": (0, _concat.default)(_context = (0, _concat.default)(_context2 = "search-result_".concat(rootId)).call(_context2, section ? "-".concat(section.id) : "", "-")).call(_context, sanitizedLabel),
      focusable: true,
      title: resultTitle,
      onClick: resultClicked,
      type: "block"
    }));
  };

  var containerClassName = (0, _classnames.default)("keyword-search", className);
  /* istanbul ignore next */

  var scrollResultIntoView = function scrollResultIntoView() {
    var selected = selectedRef.current;

    if (selected) {
      var _containerRef$current = containerRef.current,
          containerHeight = _containerRef$current.offsetHeight,
          containerScroll = _containerRef$current.scrollTop;
      var scrollDifference = selected.offsetTop - containerScroll;

      if (scrollDifference < 0) {
        selected.scrollIntoView();
      } else if (scrollDifference > containerHeight - selected.offsetHeight) {
        selected.scrollIntoView(false);
      }
    }
  };

  window.requestAnimationFrame(scrollResultIntoView);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClassName,
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement(_FormSearchBox.default, {
    className: "keyword-search__box",
    queryString: queryString,
    onKeyDown: onKeyDown,
    onValueChange: onValueChange,
    ref: function ref(search) {
      return search && search.searchBoxFocus();
    },
    width: _InputWidths.default.AUTO
  }), title && /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: "keyword-search__title",
    type: _Text.textTypes.SECTIONTITLE
  }, title), /*#__PURE__*/_react.default.createElement("ul", {
    className: "keyword-search__results",
    ref: containerRef
  }, (0, _map.default)(results).call(results, _renderSearchResult)));
};

KeywordSearchView.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  onResultClick: _propTypes.default.func,
  onValueChange: _propTypes.default.func.isRequired,
  results: _propTypes.default.array,
  queryString: _propTypes.default.string
};
KeywordSearchView.defaultProps = (_KeywordSearchView$de = {}, (0, _defineProperty2.default)(_KeywordSearchView$de, "data-id", "search-view"), (0, _defineProperty2.default)(_KeywordSearchView$de, "onResultClick", function onResultClick() {}), (0, _defineProperty2.default)(_KeywordSearchView$de, "results", []), (0, _defineProperty2.default)(_KeywordSearchView$de, "queryString", ""), _KeywordSearchView$de);
var _default = KeywordSearchView;
exports.default = _default;
module.exports = exports["default"];